var map = {
	"./role-1/role-cn.png": "TEP0",
	"./role-1/role-de.png": "qnHH",
	"./role-1/role-en.png": "ZGlQ",
	"./role-1/role-es.png": "w4ED",
	"./role-1/role-fr.png": "wSbe",
	"./role-1/role-pt.png": "Uh9h",
	"./role-2/role-cn.png": "8O7K",
	"./role-2/role-de.png": "qLR9",
	"./role-2/role-en.png": "SBFz",
	"./role-2/role-es.png": "1/A1",
	"./role-2/role-fr.png": "PQbL",
	"./role-2/role-pt.png": "KstA",
	"./role-3/role-cn.png": "zASK",
	"./role-3/role-de.png": "d6S7",
	"./role-3/role-en.png": "sv6+",
	"./role-3/role-es.png": "sxTT",
	"./role-3/role-fr.png": "NPzh",
	"./role-3/role-pt.png": "a1HA",
	"./role-4/role-cn.png": "Ig/1",
	"./role-4/role-de.png": "gGWm",
	"./role-4/role-en.png": "CcZ7",
	"./role-4/role-es.png": "eK1d",
	"./role-4/role-fr.png": "4pho",
	"./role-4/role-pt.png": "lWMa",
	"./role-5/role-cn.png": "pV8r",
	"./role-5/role-de.png": "FbFL",
	"./role-5/role-en.png": "/tNA",
	"./role-5/role-es.png": "/B7z",
	"./role-5/role-fr.png": "KxjA",
	"./role-5/role-pt.png": "oqb2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cpK8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3 ^\.\/role\-.*\.png$
// module id = cpK8
// module chunks = 1